<!-- 规则弹窗 -->
<template>
  <div class="rule-popup">
    <van-overlay
      :show="show"
      @click="close"
      :lock-scroll="false"
      class="my-overlay"
    >
      <div class="wrapper" @click.stop>
        <p class="title">兑换规则</p>
        <p class="content" v-html="appletInfo.exchangeRules"></p>
        <div class="btn" @click="close">关闭</div>
      </div>
    </van-overlay>
  </div>
</template>
<script>
export default {
  components: {},
  props: [
    'appletInfo'
  ],
  data() {
    return {
      show: false,
    }
  },
  methods: {
    close() {
      this.show = false
      this.$parent.pageFixedScreen = false
    },
    open() {
      this.show = true
      this.$parent.pageFixedScreen = true
    },

  },

}
</script>
<style lang="less" scoped>
.rule-popup {
  position: relative;
  .my-overlay {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .wrapper {
    margin: 0 auto;
    padding: 10px 20px 10px 20px;
    width: 350px;
    box-sizing: border-box;
    background: #fff;
    border-radius: 10px;
    background-size: 100% auto;
    font-size: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    // position: relative;
    // z-index: 10;

    .pic {
      width: 55px;
    }
    .title {
      padding: 10px 0;
      line-height: 1.2;
      font-weight: bold;
      font-size: 20px;
      color: #36240a;
    }
    .content {
      height: 70vh;
      overflow: auto;
      font-size: 13px;
      color: #808080;
      line-height: 2;
      word-wrap: break-word; /* 允许长单词和URL地址换行到下一行 */
      word-break: break-all; /* 在单词内部任意点断开单词，适应容器宽度 */
      :deep(img) {
        max-width: 100%;
        height: auto;
      }
      :deep(ul) {
        list-style-type: disc; /* 设置符号列表的符号为实心圆 */
        padding-left: 20px;
      }

      :deep(ol) {
        list-style-type: decimal; /* 设置数字列表的符号为数字 */
        padding-left: 20px;
      }
    }

    .btn {
      margin: 10px 0 15px 0;
      width: 109px;
      height: 40px;
      background: #000000;
      border-radius: 26px;
      font-size: 18px;
      color: #ffffff;
      line-height: 2.3;
      text-align: center;
    }
  }
}
</style>
